<template lang="pug">
v-pagination(
  v-if="length > 1"
  :length="length"
  v-model="localValue"
  :total-visible="totalVisible"
  :disabled="disabled")
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    value: Number,
    length: {
      type: Number,
      required: true,
    },
    totalVisible: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
